import { Header as HeaderWidget } from "@/components/header/index";
import { SectionPage } from "@/components/section-page";
import { LocalizationText } from "@/app/index";
import { useHeaderStyles } from "./header.styles";
import { usePageContextDelivery } from "../../context/delivery-context";
import { useMemo } from "react";

import HeaderLogoSvg from "../../static/header-logo.svg?react";

export const ModuleHeader = () => {
  const { styles } = useHeaderStyles();
  const { currentLang } = usePageContextDelivery();

  const breadcrumbItems = useMemo(
    () => [
      {
        title: (
          <LocalizationText value="products.delivery.header.breadcrumb.home" />
        ),
        href: `/${currentLang}/home`,
      },
      {
        title: (
          <LocalizationText value="products.delivery.header.breadcrumb.delivery" />
        ),
      },
    ],
    [currentLang],
  );

  return (
    <SectionPage
      classNames={{
        section: styles.section,
        body: styles.body,
      }}
    >
      <HeaderWidget
        icon={<HeaderLogoSvg />}
        title={<LocalizationText value="products.delivery.header.title" />}
        breadcrumbItems={breadcrumbItems}
      />
    </SectionPage>
  );
};
